<template>
  <div class="edit-seo">
    <div class="contentSelect">
      <el-select
        v-model="pathSelect"
        placeholder="请选择需要修改的内容类型"
        @change="_getContentType"
      >
        <el-option
          v-for="item in seoSelect"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <div v-if="Object.keys(form).length > 0">
      <el-form
        ref="ruleForm"
        :model="form"
        label-width="100px"
        class="form"
        :rules="rules"
      >
        <el-form-item label="页面标题">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="页面关键词">
          <el-input v-model="form.keywords"></el-input>
        </el-form-item>
        <el-form-item label="页面描述">
          <el-input v-model="form.description"></el-input>
        </el-form-item>
      </el-form>
      <div class="c-buttom">
        <el-button
          v-loading="saveLoing"
          type="primary"
          @click="save('ruleForm')"
          >保存</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import HomeApi from '../../network/home'
export default {
  name: 'EditSeo',
  data() {
    return {
      seoSelect: [],
      pathSelect: '',
      form: {},
      rules: {},
      saveLoing: false
    }
  },
  created() {
    const options = this.$router.options.routes[0].children
    const arr = []
    options.forEach((key) => {
      if (key.meta) {
        const obj = {}
        obj.label = key.meta.title
        obj.value = key.path
        arr.push(obj)
      }
    })
    this.seoSelect = arr
  },
  methods: {
    async _getContentType() {
      await this.handleSeoList()
    },

    async handleSeoList() {
      this.form = {}
      const result = await HomeApi.getSeo(this.pathSelect)
      if (result.code === '00000') {
        this.form = result.data
      }
    },

    // 更新seo
    save(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            const { msg } = await HomeApi.updateSeo(this.form)
            this.$message.success(msg)
          } catch (e) {
            this.$message.error(e)
          } finally {
            await this._getContentType()
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.edit-seo {
}

.form {
  margin: 0 auto;
  width: 600px;
}

.c-buttom {
  display: flex;
  justify-content: center;
}
</style>
